export const FAVORITE_GROUP_NAME = "favorites";
export const CATALOG_KEY = "favorite-catalogs";
export const ARTICLE_KEY = "favorite-articles";
